import React, { Component } from 'react'
import Radio from './radio'
import { Form } from 'formsy-react'
import { withRouter } from './../lib/router'
import createReactClass from 'create-react-class'

const HostSelector = withRouter(
	createReactClass({
		getInitialState(){
			return ({})
		},
		changeHost(data){
			const { submit } = this.props
			let selectedHost = data.newHost
			submit(selectedHost)
		},
		cancel(event){
			event.preventDefault()
			this.props.cancel()
		},
		onClick(data){
			const { submit } = this.props
			submit(data)
		},
		getHosts() {
			const { showAutomatticHost } = this.props
			const hosts = ['Bluehost', 'HostGator', 'GoDaddy', 'WP Engine', 'Flywheel', 'DreamHost', 'A2 Hosting', 'InMotion Hosting', 'Sandbox', 'Pressable', 'Pagely', 'Elementor', 'Kinsta', 'Nexcess', 'CPanel']
			if (showAutomatticHost) hosts.push('WordPress.com')
			hosts.push('Generic')
			return hosts
		},
		render(){
			//Siteground has been removed from the list below for time-being
			return (
				<div className="container">
					<Form className="bv-form" onSubmit={this.changeHost}>
						<div className="row">
							<div className="">
								<Radio 
									name="newHost" 
									title="Select Host"
									items={this.getHosts()}
									value=""
									widthClass="col-xs-4 col-md-4"
									iconClass="mdi mdi-clipboard-arrow-left"
									image={true}
									onClick={this.onClick}
								/>
							</div>
						</div>
						<div className="row bv-signup-submit">
							{this.props.cancel ? <button onClick={this.cancel} className="bv-secondary-button">Cancel</button> : <span></span>}
						</div>
					</Form>
				</div>
			)		
		}
	})	
)

export default HostSelector
